<div class="bg-white" id="layoutError">
    <div id="layoutError_content">
        <main>
            <div class="container-xl px-4">
                <div class="row gx-4 justify-content-center">
                    <div class="col-lg-6">
                        <div class="text-center mt-4">
                            <div class="r-text-error-number text-secondary heavy italic">{{errorNumber}}</div>
                            <div class="r-text-error text-secondary heavy italic">ERROR</div>
                            <img class="img-fluid mb-4 mt-n2" src="assets/img/svg/error.svg" alt="Overlanding truck with popup tent" />
                            <div class="text-primary heavy italic mb-1">{{message1}}</div>
                            <div class="text-primary heavy italic mb-3">{{message2}}</div>
                            <button class="btn btn-lg rounded-pill btn-secondary-gradient text-white fw-500" data-cy="errorHomeButton" type="button" tabindex="0" routerLink="/">
                                <div class="d-flex align-items-center"><div class="mx-3">Home</div></div></button
                            ><a class="text-xs pointer text-link text-cyan-blue primary-hover d-block mt-5" data-cy="errorPageClearCacheLink" routerLink="/clear-cache">Clear Cache</a>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
    <div id="layoutError_footer">
        <footer class="footer-admin mt-auto footer-light">
            <div class="container-xxl px-4">
                <div class="row gx-4">
                    <div class="col-md-6 small">{{copyrightString}}</div>
                    <div class="col-md-6 text-md-end small">
                        <a routerLink="/privacy-policy">Privacy Policy</a>
                        &middot;
                        <a routerLink="/terms-and-conditions">Terms &amp; Conditions</a>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</div>
